import { PlusOutlined } from '@ant-design/icons';
import {
  Alert,
  Button,
  Card,
  Col,
  Empty,
  Flex,
  Row,
  Spin,
  Typography,
} from 'antd';

import { getInfoItems } from '@pages/IntegrationParsing/data';
import {
  useIntegrationParsing,
  useIntegrationParsingEffects,
} from '@pages/IntegrationParsing/hooks';
import { Rule } from '@pages/IntegrationParsing/ui';

import '@pages/IntegrationParsing/styles/IntegrationParsing.desktop.scss';

const PF = 'integration-parsing';
const { Text } = Typography;

export const IntegrationParsing = () => {
  const {
    rules,
    addRule,
    onChangeRule,
    isLoadingPage,
    initRules,
    goToIntegrations,
    onSave,
    getTagsHandler,
    tagOptions,
    integrationData,
    deletedTags,
    onRemove,
  } = useIntegrationParsing();

  useIntegrationParsingEffects({ initRules, getTagsHandler });

  if (isLoadingPage) {
    return <Spin spinning />;
  }

  return (
    <div className={PF}>
      <div className={`${PF}__left`}>
        <Text>
          Для корректного создания клиентов/лидов из данных входящих электронных
          писем необходимо настроить правила, по которым нейросеть будет
          извлекать данные из письма.
        </Text>

        <div className={`${PF}__rules`}>
          <Flex className="full-width" vertical gap={12}>
            {rules.map((rule, index) => (
              <Rule
                key={index}
                index={index}
                onChange={onChangeRule}
                tagOptions={tagOptions}
                onRemove={onRemove}
                onlyOne={rules.length === 1}
                refetchTags={getTagsHandler}
                {...rule}
              />
            ))}
            {rules.length === 0 && <Empty description="Правила не заданы" />}
          </Flex>
        </div>

        <Button
          className={`${PF}__button`}
          type="primary"
          onClick={addRule}
          icon={<PlusOutlined />}
        >
          Добавить правило
        </Button>

        <Flex gap={16}>
          <Button className={`${PF}__button`} type="primary" onClick={onSave}>
            Сохранить
          </Button>
          <Button className={`${PF}__button`} onClick={goToIntegrations}>
            Отменить
          </Button>
        </Flex>
      </div>

      <div className={`${PF}__right`}>
        <Card title="Информация" variant="outlined" type="inner">
          <Flex vertical gap={6} className="full-width">
            {getInfoItems(integrationData).map(({ label, value, id }) => (
              <Row key={id}>
                <Col span={12}>{label}:</Col>
                <Col span={12}>
                  <Text strong>{value}</Text>
                </Col>
              </Row>
            ))}
          </Flex>
        </Card>

        {deletedTags.length > 0 && (
          <Alert
            className={`${PF}__warning`}
            type="warning"
            showIcon
            message="Часть тегов является архивной"
            description={
              <span>
                Следующие теги помечены как удалённые/архивные и не будут
                присвоены клиенту при сохранении правил:{' '}
                <b>
                  {deletedTags
                    .map((tag) => tag.Name)
                    .filter(Boolean)
                    .join(', ')}
                </b>
                .
              </span>
            }
          />
        )}
      </div>
    </div>
  );
};
